export default {
    clipRange: 'Clip range', branding: 'Intro & outro', captions: 'Captions',
    intro: 'Intro', outro: 'Outro', on: 'On', off: 'Off', captionStyle: 'On · Brand Brain style',
    preview: 'Preview requested clip', seconds: '{n}s', queued: 'Edit queued', withdraw: 'Withdraw request',
}
